import styled from 'styled-components'

export const WidgetsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 0;
`

export const WidgetContainer = styled.div<{ width?: number }>`
  position: relative;
  flex: 0 0 calc(${({ width }) => width || 100}% - 16px);
  box-sizing: border-box;
  width: ${({ width }) => (width ? `${width}%` : '100%')};
  max-width: 100%;

  @media (max-width: 768px) {
    width: 100%;
    flex: 0 0 100%;
  }
`
